// src/pages/Reports.tsx
import React, { useState } from 'react';
import { 
  Filter, 
  Download, 
  Search, 
  Calendar,
  MapPin,
  AlertTriangle,
  CheckCircle,
  Clock
} from 'lucide-react';
import ReportFilters from '../components/ReportFilters';
import  ReportsTable  from '../components/ReportsTable';
import ReportStatusChart  from '../components/ReportStatusChart';
import  CategoryDistribution  from '../components/CategoryDistribution';

export const Reports: React.FC = () => {
  const [filters, setFilters] = useState({
    status: 'all',
    category: 'all',
    ward: 'all',
    dateRange: '7days',
    search: '',
  });

  const [showFilters, setShowFilters] = useState(false);

  const handleExport = () => {
    // Export functionality
    console.log('Exporting reports...');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-[#0b2045]">Citizen Reports</h1>
          <p className="text-gray-600">Monitor and manage citizen-reported issues</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setShowFilters(!showFilters)}
            className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-[#f4f7f6] transition-colors"
          >
            <Filter size={16} className="mr-2" />
            Filters
          </button>
          <button
            onClick={handleExport}
            className="inline-flex items-center px-4 py-2 bg-[#0b2045] text-white rounded-lg text-sm font-medium hover:bg-[#152c53] transition-colors"
          >
            <Download size={16} className="mr-2" />
            Export
          </button>
        </div>
      </div>

      {/* Stats Overview */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white rounded-xl p-4 shadow-sm border-l-4 border-[#0b2045]">
          <div className="flex items-center">
            <div className="p-2 bg-[#0b2045]/10 rounded-lg mr-3">
              <AlertTriangle className="text-[#0b2045]" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Pending</p>
              <p className="text-xl font-bold text-[#0b2045]">1,245</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl p-4 shadow-sm border-l-4 border-[#ca8a04]">
          <div className="flex items-center">
            <div className="p-2 bg-[#fefce8] rounded-lg mr-3">
              <Clock className="text-[#ca8a04]" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">In Progress</p>
              <p className="text-xl font-bold text-[#0b2045]">542</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl p-4 shadow-sm border-l-4 border-[#3c8d2e]">
          <div className="flex items-center">
            <div className="p-2 bg-[#3c8d2e]/10 rounded-lg mr-3">
              <CheckCircle className="text-[#3c8d2e]" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Resolved</p>
              <p className="text-xl font-bold text-[#0b2045]">3,891</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-xl p-4 shadow-sm border-l-4 border-[#0b2045]">
          <div className="flex items-center">
            <div className="p-2 bg-[#0b2045]/10 rounded-lg mr-3">
              <MapPin className="text-[#0b2045]" size={20} />
            </div>
            <div>
              <p className="text-sm text-gray-600">Wards Active</p>
              <p className="text-xl font-bold text-[#0b2045]">48/55</p>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      {showFilters && (
        <ReportFilters filters={filters} onChange={setFilters} />
      )}

      {/* Search */}
      <div className="bg-white rounded-xl shadow-sm p-4 border border-gray-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="search"
            placeholder="Search reports by description, ward, or category..."
            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3c8d2e] focus:border-transparent"
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value })}
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
            <Calendar className="text-gray-400" size={20} />
            <select
              className="border-0 bg-transparent text-sm text-gray-600 focus:outline-none focus:ring-1 focus:ring-[#3c8d2e] rounded"
              value={filters.dateRange}
              onChange={(e) => setFilters({ ...filters, dateRange: e.target.value })}
            >
              <option value="today">Today</option>
              <option value="7days">Last 7 days</option>
              <option value="30days">Last 30 days</option>
              <option value="90days">Last 90 days</option>
            </select>
          </div>
        </div>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ReportStatusChart />
        <CategoryDistribution />
      </div>

      {/* Reports Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
        <ReportsTable filters={filters} />
      </div>
    </div>
  );
};
export default Reports;